import PostBaseTemplate from "../PostBaseTemplate";
import InstagramComponent from "./InstagramComponent";

function InstagramWrapper({
  platform,
  url,
  type,
  caption,
  creatorName,
  downloaded_path,
  videoRef,
  muted,
  onManualUnmute,
  onManualMute,
}) {
  return (
    <PostBaseTemplate platform={platform} url={url}>
      <InstagramComponent
        type={type}
        downloaded_path={downloaded_path}
        muted={muted}
        url={url}
        creatorName={creatorName}
        videoRef={videoRef}
        caption={caption}
        onManualUnmute={onManualUnmute}
        onManualMute={onManualMute}
      />
    </PostBaseTemplate>
  );
}

export default InstagramWrapper;
